<template>
	<div v-if="userHotel.isHotelShow">
		  <!-- 分配酒店弹窗 -->
	    <div class="mask allot-hotel user-center-modal">
	        <div class="e-modal small">
	            <div class="e-modal-title">Assign hotel<i class="e-modal-close" @click="userHotel.isHotelShow=false"></i></div>
	            <div class="e-modal-body auth-box-overflow">
	                <table class="auth-table stripe" cellspacing="0">
	                    <tr>
	                        <td width="36px"><input type="checkbox" v-model="checkAll" /></td>
	                        <td>Hotel name</td>
	                    </tr>
	                    <tr v-for="hotel in hotelList">
	                        <td><input type="checkbox"  v-model="hotel.checked"/></td>
	                        <td>{{hotel.HotelName}}</td>
	                    </tr>

	                </table>
	            </div>
	            <div class="e-modal-footer">
	                <div class="long-btn save-btn" @click="save">save</div>
	                <div class="long-btn cancel-btn" @click="userHotel.isHotelShow=false">cancel</div>
	            </div>
	        </div>
	    </div>
	</div>
</template>
<script>
	export default{
		name:'AllotHotels',
		props:{
			userHotel:{
				type:Object,
				default:function(){
					return{}
				}
			}
		},
		data(){
			return{
				 hotelList:[],
				 checkAll:false
			}
		},
		watch:{
			userHotel(){
				this.initTableData();
			},
			checkAll(val){
				if(val){
					this.hotelList.forEach(function(i){
						i.checked='checked'

					})
				}else{
					this.hotelList.forEach(function(i){
						i.checked=''

					})
				}				
			}
		},
		methods:{
			initTableData(){
				var limitHotels=this.userHotel.LimitHotels;
				var list=this.hotelList;
			
				for(var i=0;i<list.length;i++){
					if(limitHotels.indexOf(list[i].HotelId)>-1){
						list[i]['checked']='checked';
					}else{
						list[i]['checked']='';
					}
				}
				this.list=list;

			},
			getHotelsList(){
	            var that=this;
	            that.getRequest({
	                url: that.Api.getHotelList
	            }).then(res => {
	                if (res&&res.Result.length>0) {
	                    that.hotelList=res.Result;
	                } else {
	                    that.error({ title: 'Tips', content: 'No data is queried' });
	                }
	            });
	        },
			save(){
				var that=this;
				var Hotels=[];
				that.hotelList.forEach(function(i){
					if(i.checked){
						Hotels.push(i.HotelId)
					}
				})
				
				var params={
					NO:that.userHotel.NO,
					IsActive:null,
					Pwd:'',
					Permissions:null,
					Hotels:Hotels
				}
			
				
	            that.patchRequest({
	                url: that.Api.eidtSubUser,
	                params:params
	            }).then(res => {
	                if (res&&res.IsSuccess) {
	                    that.error({ title: 'Tips', content: 'Update successfully' });
	                	that.userHotel.isHotelShow=false;
	                	that.$emit('done')
	                } else {
	                    that.error({ title: 'Tips', content: 'Update error, please try again' });
	                }
	            });
			}
		},
		mounted(){
			this.getHotelsList();
		}
	}
</script>


// WEBPACK FOOTER //
// src/components/user/AllotHotels.vue